import { z } from 'zod';

// Warehouse location schema definition
export const warehouseLocationSchema = z.object({
  ma_vi_tri: z.string().min(1, { message: 'Mã vị trí không được để trống' }),
  ten_vi_tri: z.string().min(1, { message: 'Tên vị trí không được để trống' }),
  ten_vi_tri2: z.string().nullable().optional(),
  ghi_chu: z.string().nullable().optional(),
  status: z.string().nonempty('Trạng thái không được để trống')
});

export const searchSchema = z.object({
  ma_kho: z.string().optional(),
  ma_vi_tri: z.string().optional(),
  ten_vi_tri: z.string().optional()
});

export type WarehouseLocationFormattedData = z.infer<typeof warehouseLocationSchema>;
export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialFormValues: WarehouseLocationFormattedData = {
  ma_vi_tri: '',
  ten_vi_tri: '',
  ten_vi_tri2: null,
  ghi_chu: null,
  status: '1'
};
